import { useContext } from "react";
import { StatusTrackerDataContext, StatusTrackerModalContext } from "../context/contexts";

export const useStatusTrackerV2 = () => {
    const ctx = useContext(StatusTrackerDataContext);
    if (!ctx) throw new Error("useStatusTrackerV2 must be used within StatusTrackerV2Provider");
    return ctx;
};

export const useStatusTrackerModal = () => {
    const ctx = useContext(StatusTrackerModalContext);
    if (!ctx) throw new Error("useStatusTrackerModal must be used within StatusTrackerV2Provider");
    return ctx;
};
